import { resolveDirectAppUrl } from '@/config.js';

function appBase() {
  return resolveDirectAppUrl();
}

/** Direct product-app 14-day trial signup (with optional affiliate ref). */
export function getTrialSignupHref() {
  let href = appBase() + '/#/signup?ref=website';
  try {
    if (typeof localStorage !== 'undefined') {
      const ref = localStorage.getItem('refID');
      if (ref) href += '&afi=' + encodeURIComponent(ref);
    }
  } catch (e) {
    /* ignore */
  }
  return href;
}

/**
 * Experience IMPROVE marketing journey: interactive tour → trial → Live.
 * Use getTrialSignupHref() when you need the raw signup URL.
 */
export function getExperienceHref() {
  return '/experience';
}

export function getImproveLiveHref() {
  return '/improve-live';
}

export function getLoginHref() {
  return appBase() + '/#/login';
}

/** Canonical conversion CTAs for the marketing site. */
export const CTA = {
  watchDemo: {
    label: 'Watch the Demo',
    shortLabel: 'Watch the Demo',
    href: '/watch-demo',
    description: 'See IMPROVE in action and discover how it can help your business.',
  },
  experience: {
    label: 'Experience IMPROVE',
    shortLabel: 'Experience IMPROVE',
    href: '/experience',
    external: false,
    description:
      'Start a 14-day trial to take the interactive tour in your account, with IMPROVE Live if you want a live session.',
  },
  getStarted: {
    label: 'Buy IMPROVE',
    shortLabel: 'Buy IMPROVE',
    href: '/get-started',
    description: 'Choose your package and begin transforming learning in your organisation today.',
  },
};

export const STANDARD_CTA = {
  eyebrow: 'Ready to take the next step?',
  lead:
    'See why growing businesses are choosing IMPROVE to onboard, train and develop their people.',
};
